import * as React from "react"
import PropTypes from "prop-types"
import Icon from "components/planning_center_icon"
import { Box } from "@planningcenter/tapestry-react"
import TriggerCheckistrationsResyncButton from "./TriggerCheckistrationsResyncButton"

const CheckIns = ({ event, isActingAsStaff, checkInsSettingsPath }) => {
  return (
    <div
      className={`mt-4p line`}
      style={{
        maxWidth: 280,
        whiteSpace: "normal",
        marginBottom: 0
      }}
    >
      <>
        <div className="d-f ai-c tt-u fw-500 p-2 pb-1">
          <span
            style={{ color: "var(--t-fill-color-product-checkins-050)" }}
            className="pr-4p p-r t-2p"
          >
            <Icon symbol="check-ins#check" />
          </span>
          Check In
        </div>

        <a className="p-2 mb-4" href={checkInsSettingsPath}>
          Set up Check-Ins for this signup
        </a>

        <Box marginTop={1} paddingBottom={0.5}>
          {isActingAsStaff && <TriggerCheckistrationsResyncButton event={event} />}
        </Box>
      </>
    </div>
  )
}

CheckIns.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    signupIntegration: PropTypes.shape({
      integration_id: PropTypes.string,
      id: PropTypes.string
    })
  }),
  isActingAsStaff: PropTypes.bool,
  checkInsSettingsPath: PropTypes.string
}

export default CheckIns
